import { Routes } from '@angular/router';
import { authChildGuard, authGuard } from './core/guards/auth.guard';
import { masterGuard } from './core/guards/master.guard';
import { redirectIfAuthedGuard } from './core/guards/redirect-if-authed.guard';

export const routes: Routes = [
	{
		path: '',
		pathMatch: 'full',
		redirectTo: 'auth/login'
	},
	{
		path: 'termos-de-uso',
		loadComponent: () =>
			import('./features/termos-de-uso/termos-de-uso').then((m) => m.TermosDeUsoComponent)
	},
	{
		path: 'accept-invite',
		canActivate: [redirectIfAuthedGuard],
		loadComponent: () =>
			import('./features/accept-invite/accept-invite').then((m) => m.AcceptInviteComponent)
	},
	{
		path: 'reject-invite',
		canActivate: [redirectIfAuthedGuard],
		loadComponent: () =>
			import('./features/reject-invite/reject-invite').then((m) => m.RejectInviteComponent)
	},
	{
		path: 'auth',
		children: [
			{
				path: 'login',
				canActivate: [redirectIfAuthedGuard],
				loadComponent: () =>
					import('./features/auth/login/auth-login').then((m) => m.AuthLoginComponent)
			},
			{
				path: 'signup',
				canActivate: [redirectIfAuthedGuard],
				loadComponent: () =>
					import('./features/auth/signup/auth-signup').then((m) => m.AuthSignupComponent)
			},
			{
				path: 'verify-email',
				canActivate: [redirectIfAuthedGuard],
				loadComponent: () =>
					import('./features/auth/verify-email/auth-verify-email').then(
						(m) => m.AuthVerifyEmailComponent
					)
			},
			{
				path: 'forgot-password',
				canActivate: [redirectIfAuthedGuard],
				loadComponent: () =>
					import('./features/auth/forgot-password/auth-forgot-password').then(
						(m) => m.AuthForgotPasswordComponent
					)
			},
			{
				path: 'reset-password',
				canActivate: [redirectIfAuthedGuard],
				loadComponent: () =>
					import('./features/auth/reset-password/auth-reset-password').then(
						(m) => m.AuthResetPasswordComponent
					)
			},
			{
				path: '',
				pathMatch: 'full',
				redirectTo: 'login'
			}
		]
	},
	{
		path: 'infos',
		canActivate: [authGuard],
		canActivateChild: [authChildGuard],
		loadComponent: () =>
			import('./layout/app-layout/app-layout').then((m) => m.AppLayoutComponent),
		children: [
			{
				path: 'settings',
				children: [
					{
						path: '',
						pathMatch: 'full',
						redirectTo: 'my-settings'
					},
					{
						path: 'my-settings',
						data: { titleKey: 'menu.fixed.mySettings' },
						loadComponent: () =>
							import('./features/settings/my-data/settings-my-data').then(
								(m) => m.SettingsMyDataComponent
							)
					},
					{
						path: '',
						canActivateChild: [masterGuard],
						children: [
							{
								path: 'dashboard',
								loadComponent: () =>
									import('./features/settings/dashboard/settings-dashboard').then(
										(m) => m.SettingsDashboardComponent
									)
							},
							{
								path: 'users',
								loadComponent: () =>
									import('./features/settings/system-users/settings-system-users').then(
										(m) => m.SettingsSystemUsersComponent
									)
							},
							{
								path: 'audit',
								loadComponent: () =>
									import('./features/settings/audit/settings-audit').then(
										(m) => m.SettingsAuditComponent
									)
							},
							{
								path: 'exams',
								loadComponent: () =>
									import('./features/settings/exams/settings-exams').then(
										(m) => m.SettingsExamsComponent
									)
							},
							{
								path: 'lab-test-types',
								loadComponent: () =>
									import('./features/settings/exams/settings-exams-redirect').then(
										(m) => m.SettingsExamsRedirectComponent
									),
								data: { tab: 'catalog' }
							},
							{
								path: 'lab-test-panels',
								loadComponent: () =>
									import('./features/settings/exams/settings-exams-redirect').then(
										(m) => m.SettingsExamsRedirectComponent
									),
								data: { tab: 'panels' }
							},
							{
								path: 'vaccine-types',
								loadComponent: () =>
									import('./features/settings/vaccine-types/settings-vaccine-types').then(
										(m) => m.SettingsVaccineTypesComponent
									)
							},
							{
								path: 'preventives',
								loadComponent: () =>
									import('./features/settings/preventives/settings-preventives').then(
										(m) => m.SettingsPreventivesComponent
									)
							},
							{
								path: 'diseases',
								loadComponent: () =>
									import('./features/settings/diseases/settings-diseases').then(
										(m) => m.SettingsDiseasesComponent
									)
							},
							{
								path: 'breeds',
								loadComponent: () =>
									import('./features/settings/breeds/settings-breeds').then(
										(m) => m.SettingsBreedsComponent
									)
							}
						]
					}
				]
			},
			{
				path: 'pets/alerts',
				loadComponent: () =>
					import('./features/pets/alerts/pets-alerts-page').then(
						(m) => m.PetsAlertsPageComponent
					)
			},
			{
				path: 'pets',
				loadChildren: () => import('./features/pets/pets.routes').then((m) => m.PETS_ROUTES)
			},
			{
				path: '',
				pathMatch: 'full',
				redirectTo: 'pets'
			},
			{
				path: '**',
				redirectTo: 'pets'
			}
		]
	},
	{
		path: '**',
		redirectTo: 'auth/login'
	}
];
